import _ from "lodash";
import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export function megapotServers(state: [] = [], action: Action) {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST_SUCCESS:
            let response = action.payload;
            return response;
        default:
            return state;
    }
}

export function megapotServersLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST:
            return true;
        case ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST_SUCCESS:
        case ConfigurationsActionTypes.GET_MEGAPOT_SERVER_LIST_FAIL:
            return false;
        default:
            return state;
    }
}
